import React, { Fragment, useEffect, useState } from 'react';
import { Modal, Card, Form, Button} from 'react-bootstrap';
import VisarCierre from './components/visar-cierre';
import HeaderInfo from './components/herader-info';
import { useFormik } from 'formik';
import DetalleCierre from './components/detalle-cierre';
import { validationSchemasCierre } from '../../../common/validation-Schemas-cierre';
import { Auth, LoadingComponent } from 'recupero-comunes';
import { useDispatch, useSelector } from 'react-redux';
import { serviceGetCfgForm, serviceVisarRechazarCierre } from '../../../api/api-confirmar-cierre';
import { obtenerTareasPendientes } from '../../../store/actions/administracion-caso-action';
import Mensajes from '../../mensajes';

const CierreMoldal = ({ action, showModal, setShowModal, implicado, idTrxOrigen, idProcesoJud }) => {
    const dispatch = useDispatch();
    const data_encargado = useSelector((state) => state.encargadoCompaniaReducer);
    const { llaves } = data_encargado;
    const [loading, setLoading] = useState(false);
    const [cfg_form, setCfg_form] = useState(null);
    const [showDetalle, setShowDetalle] = useState(false);
    const [solicitud, setSolicitud] = useState(null);

    const [responseData, setResponseData] = useState(null);
    const [showToast, setShowToast] = useState(false);
    const [showModalConfirm, setShowModalConfirm] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    const [dataSubmit, setDataSubmit] = useState(null);

    useEffect(() => {
        if (showModal) getCfgForm();
    }, [showModal])

    const getCfgForm = async () => {
        const query = Buffer.from(JSON.stringify({ rutcia: llaves.idOrgCaso, idform: 56 })).toString('base64');
        const response = await serviceGetCfgForm(query);

        setCfg_form(response);
    }

    const handleCloseToast = () => {
        setShowToast(false);
        if (responseData?.code === 1) { handleCloseModal(); reloadTareasPendientes() }
    }

    const handleCloseModal = () => {
        setShowModal(false); formik.resetForm();
    }

    const reloadTareasPendientes = () => {
        let query = Buffer.from(JSON.stringify({ idCaso: llaves?.idCaso, idUsuario: Auth.currentUser().rutUsuario })).toString('base64');
        dispatch(obtenerTareasPendientes(query));
    }

    const visarRechazarCierre = async (data) => {
        const dataRequest = showModalConfirm ? dataSubmit : data;
        setLoading(true);
        setShowModalConfirm(false);
        const response = await serviceVisarRechazarCierre(dataRequest);

        setLoading(false);
        setResponseData(response);
        setShowToast(true);
    }

    const formik = useFormik({
        initialValues: {
            confirmaCierre: "",
            motivoRechazo: "",
            honorario: false,
            comentarioRespuesta: "",
        },
        validationSchema: validationSchemasCierre(action),
        onSubmit: async (data) => {
            let dataResult = { ...data };

            dataResult.idCaso = llaves.idCaso;
            dataResult.idOrganizacion = llaves.idOrgCaso;
            dataResult.idUsuario = Auth.currentUser().rutUsuario;
            dataResult.idSolicitud = solicitud?.idSolicitud;
            dataResult.situacionEstado = solicitud?.idMotivoSolDcto;
            dataResult.honorarioPendiente = data.honorario ? 1 : 0;
            dataResult.idTrxOrigen = idTrxOrigen;
            setDataSubmit(dataResult);

            if (showConfirm) setShowModalConfirm(true);
            else visarRechazarCierre(dataResult);
        }
    })

    return (
        <Fragment>
            <LoadingComponent show={loading} />

            <Modal show={showModal} onHide={setShowModal} size='xl'>
                <Card>
                    <Form onSubmit={formik.handleSubmit}>
                        <Card.Header className='cardHeader'>
                            {cfg_form && cfg_form["modalconfirmarcierre-title"]}
                        </Card.Header>

                        <Card.Body style={{ padding: '10px' }}>
                            <HeaderInfo {...formik} cfg_form={cfg_form} implicado={implicado} solicitud={solicitud} setSolicitud={setSolicitud} />
                            <VisarCierre {...formik} cfg_form={cfg_form} action={action} solicitud={solicitud} setShowConfirm={setShowConfirm} />
                        </Card.Body>
                        {showToast && 
                            <Mensajes
                                showToast={showToast}
                                handleCloseToast={handleCloseToast}
                                delay={5000}
                                responseData={responseData}
                            ></Mensajes>
                        }
                        <Card.Footer style={{ display: 'flex', justifyContent: 'right', gap: '8px' }}>
                            <Button className='w-auto' variant='outline-info' onClick={handleCloseModal}>
                                {cfg_form && cfg_form["modalconfirmarcierre-btn-volver"]}
                            </Button>
                            <Button className='w-auto buttonLetter' variant='warning' onClick={() => setShowDetalle(true)}>
                                {cfg_form && cfg_form["modalconfirmarcierre-btn-detallecierre"]}
                            </Button>
                            <Button type="submit" className='w-auto buttonLetter' variant='danger'>
                                {cfg_form && cfg_form["modalconfirmarcierre-btn-visar"]}
                            </Button>
                        </Card.Footer>
                    </Form>
                </Card>
            </Modal>

            <Modal show={showModalConfirm} onHide={() => setShowModalConfirm(false)} size='md'>
                <Card>
                    <Card.Header className='mt-0 mb-0' as='h6' style={{ backgroundColor: '#4F517A', color: 'white' }}>Confirmación</Card.Header>
                    <Card.Body>¿Confirma Cierre del Caso?</Card.Body>

                    <Card.Footer style={{ display: 'flex', justifyContent: 'center' }}>
                        <Button className='m-2 w-auto' variant='outline-info' onClick={() => setShowModalConfirm(false)}>No</Button>
                        <Button className='m-2 w-auto' variant='danger' onClick={visarRechazarCierre}>Si</Button>
                    </Card.Footer>
                </Card>
            </Modal>

            {showDetalle && <DetalleCierre
                showModal={showDetalle}
                setShowModal={setShowDetalle}
                implicado={implicado}
                solicitud={solicitud}
                idProcesoJud={idProcesoJud}
            />}

            <style type='text/css'>
                {`
                    .cardHeader {
                        background-color: #77789b;
                        color: #FFFFFF;
                    }
                    .buttonLetter {
                        color: #FFFFFF;
                    }
                `}
            </style>
        </Fragment>
    )
}

export default CierreMoldal;